import axiosInstance from "../AxiosInstance"

export const retrieveMemberPackages = ({id, setPackagesData, setIsLoading, setErrors}) => {
    setIsLoading && setIsLoading(true)
    axiosInstance.get(`/profile/${id}/member-packages`).then((response) => {
        setPackagesData && setPackagesData(response.data.data)
        setIsLoading && setIsLoading(false)
    }).catch((error) => {
        console.log(error)
        setIsLoading && setIsLoading(false)
        if (error.response && error.response.status === 422) {
            setErrors && setErrors(error.response.data.message)
        } else {
            setErrors && setErrors(error.response?.data?.message || error.message)
        }
    })
}

export const deletePackage = ({profileId, packageId, setIsLoading, setErrors, onSuccess}) => {
    setIsLoading && setIsLoading(true)
    axiosInstance.delete(`/profile/${profileId}/member-packages/${packageId}`).then(() => {
        setIsLoading && setIsLoading(false)
        onSuccess && onSuccess()
    }).catch((error) => {
        console.log(error)
        setIsLoading && setIsLoading(false)
        setErrors && setErrors(error.response?.data?.message || error.message)
    })
}

export const savePackage = ({id, packageData, setIsLoading, setErrors, setGeneralError, setMessage, onSaveSuccess, setShow}) => {
    setIsLoading && setIsLoading(true)
    axiosInstance.post(`/profile/${id}/member-packages`, packageData).then((response) => {
        setMessage && setMessage(response.data.message)
        setShow && setShow(false)
        onSaveSuccess && onSaveSuccess()
        setIsLoading && setIsLoading(false)
    }).catch((error) => {
        console.log(error)
        setIsLoading && setIsLoading(false)
        if (error.response && error.response.status === 422) {
            if (error.response.data.errors && typeof error.response.data.errors === 'object' && !Array.isArray(error.response.data.errors)) {
                setErrors && setErrors(error.response.data.errors)
            } else {
                setGeneralError && setGeneralError(error.response.data.message)
            }
        } else {
            setGeneralError && setGeneralError(error.response?.data?.message || error.message)
        }
    })
}
